<div class="container-dialog">
    <div class="d-flex align-items-center justify-content-between w-100 gap-1">
        <button class="d-flex align-items-center justify-content-center p-2 botao-com-icone" (click)="cancelar()">
            <object class="tamanho-icone" data="assets\agview-connect\arrow_back_white.svg"
                type="image/svg+xml">
                {{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_TEXT.BACK" | transloco }}
            </object>
        </button>
        <div class="d-flex align-items-center barra-pesquisa w-100">
            <span class="titulo-dialog">{{data?.titulo}}</span>
        </div>
    </div>

    <div class="container-input-dialog">
        <label for="dialog-input" class="subtitulo-dialog">
            {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_PARAMETRO.INSTRUCTION" | transloco }}
        </label>
        <input id="dialog-input" type="number" inputmode="numeric" class="input-dialog campo-dialog" 
            [placeholder]="'COMPONENTS.AGVIEW_CONNECT.DIALOG_PARAMETRO.PLACEHOLDER' | transloco"
            (keydown)="permitirSomenteNumeros($event, parametro.value)" (keydown.enter)="enviar(parametro.value)"
            [max]="99999" #parametro [value]="data?.valor > 0 ? data?.valor : null">
    </div>

    <button class="input-dialog botao-confirmar" (click)="enviar(parametro.value)">
        <object data="assets\agview-connect\check_white.svg" type="image/svg+xml">
            {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_PARAMETRO.CONFIRM" | transloco }}
        </object>
        {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_PARAMETRO.CONFIRM" | transloco }}
    </button>
</div>